// ACTIONS
export const FETCH_SHARE_WITH_EMAILS_LIST = 'FETCH_SHARE_WITH_EMAILS_LIST';
export const UPDATE_SHARE_WITH_EMAILS_LIST = 'UPDATE_SHARE_WITH_EMAILS_LIST';
export const RESEND_SHARE_WITH_EMAIL = 'RESEND_SHARE_WITH_EMAIL';
export const REMOVE_EMAIL_FROM_SHARE_WITH = 'REMOVE_EMAIL_FROM_SHARE_WITH';
export const FETCH_GROUP_SHARES = 'FETCH_GROUP_SHARES';
export const UPDATE_GROUP_SHARES = 'UPDATE_GROUP_SHARES';
export const RESEND_GROUP_SHARE = 'RESEND_GROUP_SHARE';
export const REMOVE_GROUP_SHARE_FOR_EMAIL = 'REMOVE_GROUP_SHARE_FOR_EMAIL';
